module.exports = __webpack_public_path__ + "img/ningbo.b364dcc9.png";